import { render, staticRenderFns } from "./HelpInfoIcon.vue?vue&type=template&id=81744e3a&scoped=true"
import script from "./HelpInfoIcon.vue?vue&type=script&lang=js"
export * from "./HelpInfoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81744e3a",
  null
  
)

export default component.exports